import { getQueryStringParameter } from '../../../helpers';

import {
  setupFrequentInvestorFields,
  setupInvestmentsInUnlicensedUndertakingsFields,
  setupManagedCreditInstitutionFields,
  setupWorkedInCreditInstitutionFields,
} from '../non_professional_supplemental_step';

$(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'non_professional_supplemental') {
    return;
  }

  setupFrequentInvestorFields($form);
  setupManagedCreditInstitutionFields($form);
  setupWorkedInCreditInstitutionFields($form);
  setupInvestmentsInUnlicensedUndertakingsFields($form);
});
